<template>
  <pop-up-window
    :show="this.$store.state.displayEditLeGeneral"
    :showClose="false"
    @close="close"
    class="doc-statuses-popup"
    fixed
  >
    <template #header>Edit General</template>
    <template #content>
      <div class="flex flex-row flex-nowrap">
        <div class="flex flex-col w-1/2 mr-12">
          <Field
            title="Name: *"
            type="text"
            @input="nameInvalid = false"
            :hasError="nameInvalid"
            v-model="formData.name"
          />
          <span v-if="nameInvalid" class="text-primary-3"
            >Name is required</span
          >
          <Field
            title="Branding ID:"
            type="text"
            v-model="formData.brandingId"
          />
          <Field
            title="Internal name: "
            type="text"
            v-model="formData.internalName"
            :copySuffix="false"
          />
          <Field
            title="Legal registration number:"
            type="text"
            v-model="formData.legalRegistrationNumber"
          />
          <Field title="legalForm:" type="text" v-model="formData.legalForm" />
        </div>
        <div class="flex flex-col w-1/2 mr-12">
          <Field
            title="Portal link:"
            type="text"
            v-model="formData.portalLink"
            :copySuffix="false"
          />
          <FileUpload
            id="editGeneralLogo"
            :isLegalEntity="true"
            :delSuffix="true"
            @delete-value="deleteLogoValue"
            @update-value="changeLogoValue"
            accept="image/png, image/jpeg"
            title="Logo:"
            :data="formData.logo"
          />
          <div>
            <p class="mb-1 font-bold">Country code:</p>
            <Dropdown
              id="countryCode"
              :select-none="true"
              @update-value="updateSelectedCountryCode"
              :data="countryCodes"
              :selected="formData.countryCode"
            />
          </div>
          <div>
            <p class="font-bold">Project Status:</p>
            <Dropdown
              :data="optionStatuses"
              :selected="status.projectStatus"
              @update-value="updateProjectStatus"
              class="mb-3"
              :disabled="!isSgPartnerPortal"
            />
            <div class="flex flex-row">
              <p class="font-bold mr-2">Is Delinquent payer:</p>
              <ToggleSlide
                class="w-min"
                @update-value="
                  status.isDelinquentPayer = !status.isDelinquentPayer
                "
                :bool="status.isDelinquentPayer"
                :renew-bool="true"
                :disabled="!isSgPartnerPortal"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-rows-1 justify-items-end">
        <div>
          <button class="btn shadow-md mr-2" @click="update">Update</button>
          <button
            class="btn shadow-md mr-2 nymus-orange color-white"
            @click="close"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </pop-up-window>
</template>
<script>
import Field from "../Field.vue";
import FileUpload from "../FileUpload.vue";
import PopUpWindow from "../PopUp.vue";
import ToggleSlide from "@/components/ToggleSlide.vue";
import Dropdown from "@/components/Dropdown.vue";
import countryCodes from "@/countryCodes";

export default {
  name: "EditGeneral",
  components: {
    Dropdown,
    ToggleSlide,
    PopUpWindow,
    FileUpload,
    Field,
  },
  data() {
    return {
      nameInvalid: false,
      countryCodes,
      status: {
        projectStatus: "CREATED",
        isDelinquentPayer: false,
      },
      formData: {},
    };
  },
  mounted() {
    this.initData();
  },
  watch: {
    "$store.state.activeLE": {
      handler() {
        this.initData();
      },
    },
  },
  computed: {
    optionStatuses() {
      let statuses = this.$store.state.statusesSG.map((status) => {
        return { name: status.status };
      });

      if (statuses[statuses.length - 1].name === "NOT_PAID") statuses.pop();

      // Le can not be a Partner, only SG
      const index = statuses.findIndex((status) => status.name === "PARTNER");
      if (index !== -1) statuses.splice(index, 1);

      return statuses;
    },
    isSgPartnerPortal() {
      return this.$store.state.activeSG.status?.projectStatus === "PARTNER";
    },
  },
  methods: {
    changeLogoValue(event) {
      this.formData.logo = event.value;
    },
    deleteLogoValue(event) {
      delete this.formData.logo;
    },
    updateSelectedCountryCode(newCountryCode) {
      if (typeof newCountryCode === "object")
        newCountryCode = newCountryCode[0];
      if (newCountryCode < 0) return;
      this.formData.countryCode = countryCodes[newCountryCode].name;
    },
    updateProjectStatus(e) {
      if (typeof e === "object") e = e[0];
      if (e < 0) return;
      this.status.projectStatus = this.optionStatuses[e].name;
    },

    initData() {
      let legalEntity = this.$store.state.activeLE;

      this.formData = {
        name: legalEntity.name ?? "",
        brandingId: legalEntity.brandingId ?? "",
        portalLink: legalEntity.legalEntityConfig?.portalLink ?? "",
        internalName: legalEntity.internalName ?? "",
        logo: legalEntity.legalEntityConfig?.logo ?? undefined,
        legalRegistrationNumber: legalEntity.legalRegistrationNumber ?? "",
        legalForm: legalEntity.legalForm
          ? JSON.parse(JSON.stringify(legalEntity.legalForm))
          : "",
        countryCode: legalEntity.legalEntityConfig?.countryCode ?? "",
      };

      //set status le
      // only when partner is chosen on SG, the LE can have a different value
      const sourceStatus = this.isSgPartnerPortal
        ? this.$store.state.activeLE.status
        : this.$store.state.activeSG.status;

      this.status.projectStatus = sourceStatus?.projectStatus ?? "CREATED";
      this.status.isDelinquentPayer = sourceStatus?.isDelinquentPayer ?? false;
    },
    close() {
      this.nameInvalid = false;
      this.initData();
      this.$store.state.displayEditLeGeneral = false;
    },
    async update() {
      let hasErrors = this.validate();
      if (!hasErrors) {
        if (this.isSgPartnerPortal) {
          try {
            let payloadStatus = {
              sgId: this.$store.state.activeSG.supplierGroupId,
              leId: this.$store.state.activeLE.entityNumber,
              status: { ...this.status },
            };

            await this.$store.dispatch(
              "EditSettingsLegalEntity",
              payloadStatus,
            );
            if (this.$store.state.responseStatus === 200) {
              this.$store.commit("toggleAlert", {
                title: "Edit Legal entity",
                text: "Status successfully edited",
              });
            }
          } catch (e) {
            this.$store.commit("displayErrorAlert", true);
            this.$store.commit("setErrorAlertText", e.message);
          }
        }

        if (this.formData.internalName === "")
          delete this.formData.internalName;
        if (this.formData.legalRegistrationNumber === "")
          delete this.formData.legalRegistrationNumber;
        if (this.formData.legalForm === "") delete this.formData.legalForm;
        if (this.formData.brandingId === "") delete this.formData.brandingId;
        if (this.formData.portalLink === "") delete this.formData.portalLink;

        let payload = {
          sgId: this.$store.state.activeSG.supplierGroupId,
          leId: this.$store.state.activeLE.entityNumber,
          edit: "info",
          body: this.formData,
        };

        await this.$store.dispatch("EditLegalEntity", payload);
        if (this.$store.state.responseStatus === 200) {
          this.$store.commit("toggleAlert", {
            title: "Edit Legal entity",
            text: "General successfully edited",
          });
        }
      }
    },
    validate() {
      let hasErrors;
      this.nameInvalid = false;

      if (this.formData.name === "") {
        hasErrors = true;
        this.nameInvalid = true;
      }
      return hasErrors;
    },
  },
};
</script>
